import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigation } from '@react-navigation/native'
import { ChatlikeNotificationBanner } from '@src/components/notifications/ChatlikeNotificationBanner'
import { userSelector } from '@src/selectors/app'
import { recordByosVideoCallsUpsellInteraction } from '../../utils'
import { ByosVideoCallsUpsellStep } from '../../constants'

export const NutritionCoachingChatlikeBanner = () => {
  const user = useSelector(userSelector)
  const primaryCoachingKind = user?.primaryCoachingKind
  const showInsuranceUi = primaryCoachingKind?.insuranceReimbursable === true
  const navigation = useNavigation()
  const [dismissed, setDismissed] = useState(false)

  if (!showInsuranceUi || dismissed) {
    return null
  }

  const onAction = () => {
    if (user) {
      recordByosVideoCallsUpsellInteraction(ByosVideoCallsUpsellStep.ChatlikeNotification, user.id)
    }
    navigation.navigate('InsuranceQuestionnaire', {
      skipIntroScreen: true,
    })
    setDismissed(true)
  }

  const onDismiss = () => {
    if (user) {
      recordByosVideoCallsUpsellInteraction(ByosVideoCallsUpsellStep.ChatlikeNotification, user.id)
    }
    setDismissed(true)
  }

  return (
    <ChatlikeNotificationBanner
      action={onAction}
      dismiss={onDismiss}
      content="Nutritionist coaching for $0 out-of-pocket. Check your eligibility today."
      actionButtonLabel="See If You Qualify"
    />
  )
}
